import { render } from "./transmissions.vue?vue&type=template&id=740533e1"
import script from "./transmissions.vue?vue&type=script&lang=js"
export * from "./transmissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__